<template>
  <div>
    <Select class="left btnarea" v-model="changetime" style="width:60px;display:">
      <Option
        v-for="item in timepick"
        :value="item.value"
        :key="'default'+item.value"
      >{{ item.label }}
      </Option>
    </Select>
    <span class="left mx-1 text-right" style="width: 40px;">
      {{ realtime }} 秒
    </span>
    <Button type="primary" @click="refresh()" :loading="loading" class="left mx-1">
      刷新
    </Button>
  </div>
</template>

<script>
  export default {
    props: {
      chgtime: 0,
      closeaarea:Array,
      rTime: 0,
      liveshowAllPath: Boolean
    },
    data(){
      return{
        changetime: this.chgtime,
        timepick: this.closeaarea,
        interval: null,
        realtime: this.rTime,
        loading: false
      }
    },
    watch: {
      liveshowAllPath () {
        this.refresh()
      }
    },
    created(){
      this.retime();
    },
    destroyed(){
      clearInterval(this.interval);
    },
    methods:{
      //重制时间
      refresh(status = true) {
        this.loading = status
        this.$Eventhub.$emit('liveshow-refresh')
        this.realtime = this.changetime;
        this.retime();
        setTimeout(() => { this.loading = false }, 2000)
      },
      //倒数时间
      retime() {
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (--this.realtime <= -1) {
            this.realtime = this.changetime;
            this.refresh(false);
          }
        }, 1000);
      }
    }
  }
</script>
